import {createBrowserRouter} from "react-router";
import RootLayout from "../layout/RootLayout";
import Home from "../pages/Home/Home";
import About from "../pages/About/About";
import Blogs from "../pages/Blogs/Blogs";
import OurFleet from "../pages/OurFleet/OurFleet";
import Contact from "../pages/Contact/Contact";
import AreaCovered from "../pages/AreaCovered/AreaCovered";
import BlogDetails from "../pages/Blogs/BlogDetails";
import Loading from "../shared/Loading";
import BookATaxi from "../pages/BookATaxi/BookATaxi";
import Services from "../pages/Services/Services";

import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import CancellationAndRefunds from "../pages/CancellationAndRefunds/CancellationAndRefunds";
import TermsAndConditionPages from "../pages/TermsAndConditionPages/TermsAndConditionPages";
import CabChargeTaxi from "../pages/CabChargeTaxi/CabChargeTaxi";
import CorporateTips from "../pages/Services/CorporateTips/CorporateTips";
import AirportShuttle from "../pages/Services/AirportShuttle/AirportShuttle";
import TaxiSydneyService from "../pages/Services/TaxiSydneyService/TaxiSydneyService";
import BookTaxiSydneyAiport from "../pages/Services/BookTaxiSydneyAirport/BookTaxiSydneyAirport";
import BabySeatTaxi from "../pages/Services/BabySeatTaxi/BabySeatTaxi";
import WheelChairTaxi from "../pages/Services/WheelChairTaxi/WheelChairTaxi";
import PageNotFound from "../pages/PageNotFound/PageNotFound";
import CorporateTransportService from "../pages/Services/CorporateTransportService/CorporateTransportService";
import CruiseTerminalTransfer from "../pages/Services/CruiseTerminalTransfer/CruiseTerminalTransfer";
import WeddingTransfer from "../pages/Services/WeddingTransfer/WeddingTransfer";
import EventTransfer from "../pages/Services/EventTransfer/EventTransfer";
import PercelDelivery from "../pages/Services/PercelDelivery/PercelDelivery";
import MaxiTaxiService from "../pages/Services/MaxiTaxiService/MaxiTaxiService";
import LuxuryTransfer from "../pages/Services/LuxuryTransfer/LuxuryTransfer";
import CoveredLocation from "../pages/AreaCovered/CoveredLocation/CoveredLocation";
import SydneyAirportLocation from "../pages/SydneyAirportLocation/SydneyAirportLocation";
import TaxiMaxiServiceIn from "../pages/taxi-maxi-service-in/TaxiMaxiServiceIn";
import Blog1Details from "../pages/Blogs/Blog1Details";
import Blog2Details from "../pages/Blogs/Blog2Details";
import Blog3Details from "../pages/Blogs/Blog3Details";
import Blog4Details from "../pages/Blogs/Blog4Details";
import Blog5Details from "../pages/Blogs/Blog5Details";
import Blog6Details from "../pages/Blogs/Blog6Details";
import Blog7Details from "../pages/Blogs/Blog7Details";
import Blog8Details from "../pages/Blogs/Blog8Details";
import Blog9Details from "../pages/Blogs/Blog9Details";
import Blog10Details from "../pages/Blogs/Blog10Details";
import Blog11Details from "../pages/Blogs/Blog11Details";
import Blog12Details from "../pages/Blogs/Blog12Details";
import Blog13Details from "../pages/Blogs/Blog13Details";
import Blog14Details from "../pages/Blogs/Blog14Details";
import Blog15Details from "../pages/Blogs/Blog15Details";

const router = createBrowserRouter([
  {
    path: "/",
    Component: RootLayout,
    children: [
      {
        index: true,
        Component: Home,
        loader: async () => {
          const res = await fetch("/service.json");
          return res.json();
        },
        hydrateFallbackElement: <Loading />,
      },
      {
        path: "/about",
        Component: About,
      },
      {
        path: "/services",
        Component: Services,
        children: [
          {
            index: true,
            Component: BookTaxiSydneyAiport,
          },
          {
            path: "book-taxi-sydney-airport",
            Component: BookTaxiSydneyAiport,
          },
          {
            path: "baby-seat-taxi-sydney",
            Component: BabySeatTaxi,
          },
          {
            path: "wheelchair-accessible-taxi",
            Component: WheelChairTaxi,
          },
          {
            path: "corporate-transport-services",
            Component: CorporateTransportService,
          },
          {
            path: "cruise-terminal-transfer",
            Component: CruiseTerminalTransfer,
          },
          {
            path: "wedding-transfer",
            Component: WeddingTransfer,
          },
          {
            path: "event-transfer",
            Component: EventTransfer,
          },
          {
            path: "parcel-delivery",
            Component: PercelDelivery,
          },
          {
            path: "maxi-taxi-service",
            Component: MaxiTaxiService,
          },
          {
            path: "luxury-transfer",
            Component: LuxuryTransfer,
          },
          {
            path: "taxi-sydney-service",
            Component: TaxiSydneyService,
          },
          {
            path: "airport-shuttle",
            Component: AirportShuttle,
          },
          {
            path: "corporate-tips",
            Component: CorporateTips,
          },
        ],
      },
      {
        path: "/book-a-taxi",
        Component: BookATaxi,
      },
      {
        path: "/area-covered",
        Component: AreaCovered,
      },
      {
        path: "/taxi-maxi-service-in",
        Component: TaxiMaxiServiceIn,
        loader: async () => {
          const res = await fetch("/service.json");
          return res.json();
        },
        hydrateFallbackElement: <Loading />,
      },
      {
        path: "/taxi-maxi-service-in/:location",
        Component: CoveredLocation,
        loader: async () => {
          const res = await fetch("/service.json");
          return res.json();
        },
        hydrateFallbackElement: <Loading />,
      },
      {
        path: "/book-taxi-maxi-service-in-sydney-airport",
        Component: SydneyAirportLocation,
        loader: async () => {
          const res = await fetch("/service.json");
          return res.json();
        },
        hydrateFallbackElement: <Loading />,
      },
      {
        path: "/blogs",
        Component: Blogs,
      },
      {
        path: "/best-transportation-options-for-weddings-and-events-in-campbelltown",
        Component: Blog1Details,
      },
      {
        path: "/corporate-taxi-services-in-sydney-what-to-expect-and-how-to-book",
        Component: Blog2Details,
      },
      {
        path: "/how-to-book-a-taxi-in-campbelltown-phone-online-app-options",
        Component: Blog3Details,
      },
      {
        path: "/early-morning-airport-transfers-taxi-vs-train",
        Component: Blog4Details,
      },
      {
        path: "/event-transport-tips-for-stadiums-function-centres-venues",
        Component: Blog5Details,
      },
      {
        path: "/how-to-choose-the-best-taxi-service-in-campbelltown-nsw",
        Component: Blog6Details,
      },
      {
        path: "/accessibility-and-special-needs-taxi-services-explained",
        Component: Blog7Details,
      },
      {
        path: "/maxi-taxi-vs-standard-taxi-which-one-should-you-book",
        Component: Blog8Details,
      },
      {
        path: "/top-reasons-to-pre-book-a-taxi-instead-of-hailing-one",
        Component: Blog9Details,
      },
      {
        path: "/taxi-safety-tips-for-passengers-in-sydney-nsw",
        Component: Blog10Details,
      },
      {
        path: "/campbelltown-taxi-service-vs-uber-which-is-cheaper-and-more-reliable",
        Component: Blog11Details,
      },
      {
        path: "/sydney-airport-taxi-from-campbelltown-fixed-price-travel-time-and-booking-tips",
        Component: Blog12Details,
      },
      {
        path: "/cabcharge-taxi-service-in-campbelltown-how-to-pre-book",
        Component: Blog13Details,
      },
      {
        path: "/how-cabcharge-supports-safer-taxi-transactions",
        Component: Blog14Details,
      },
      // {
      //   path: "/cabcharge-taxi-to-sydney-airport-from-campbelltown",
      //   Component: Blog15Details,
      // },
     
      {
        path: "/fleet",
        Component: OurFleet,
        loader: async () => {
          const res = await fetch("/fleet.json");
          return res.json();
        },
        hydrateFallbackElement: <Loading />,
      },
      {
        path: "/cabcharge-taxi",
        Component: CabChargeTaxi,
      },
      {
        path: "/terms-and-condition",
        Component: TermsAndConditionPages,
      },
      {
        path: "/privacy-policy",
        Component: PrivacyPolicy,
      },
      {
        path: "/cancellation-and-refunds",
        Component: CancellationAndRefunds,
      },
      {
        path: "/contact",
        Component: Contact,
      },
      {
        path: "/*",
        Component: PageNotFound,
      },
    ],
  },
]);
export default router;
